import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { cn } from "@/lib/utils";

const ANY = "__any__";

export interface FilterSelectProps {
  label: string;
  anyLabel: string;
  value: string | null;
  options: { value: string; label: string }[];
  onChange: (value: string | null) => void;
  className?: string;
}

/** Select whose first option clears the filter. */
export const FilterSelect = ({
  label,
  anyLabel,
  value,
  options,
  onChange,
  className,
}: FilterSelectProps) => (
  <Select
    value={value ?? ANY}
    onValueChange={(next) => onChange(next === ANY ? null : next)}
  >
    <SelectTrigger
      aria-label={label}
      className={cn(
        "h-8 w-auto min-w-36",
        value && "border-primary",
        className,
      )}
    >
      <SelectValue />
    </SelectTrigger>
    <SelectContent>
      <SelectItem value={ANY}>{anyLabel}</SelectItem>
      {options.map((option) => (
        <SelectItem key={option.value} value={option.value}>
          {option.label}
        </SelectItem>
      ))}
    </SelectContent>
  </Select>
);
